import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  PaidFeature,
  SubscriptionPlan,
  SubscriptionWithPaidFeatures,
} from '../../../projects/client';

export namespace DemoSettingsActions {
  export const addFeatures = createAction(
    '[DEMO SETTINGS] Add features',
    props<{ resourceId: string; features: PaidFeature[] }>()
  );

  export const removeFeatures = createAction(
    '[DEMO SETTINGS] Remove features',
    props<{ resourceId: string; features: PaidFeature[] }>()
  );

  export const updatePlan = createAction(
    '[DEMO SETTINGS] Update plan',
    props<{ resourceId: string; plan: SubscriptionPlan }>()
  );

  export const loadDemoConfig = createActionGroup({
    source: '[DEMO SETTINGS] Load config from session storage',
    events: {
      attempt: emptyProps(),
      success: props<{ selectSubscriptionWithPaidFeatures: SubscriptionWithPaidFeatures[] }>(),
      empty: emptyProps(),
      error: props<{ error: any }>(),
    },
  });

  export const removeDemoConfig = createAction(
    '[DEMO SETTINGS] remove config from session storage'
  );
}
